export const Options = {
    Salutation: [
        { text: "männlich", value: "m" },
        { text: "weiblich", value: "w" },
        { text: "divers", value: "d" },
    ],
     BecomingAwareThrough: [
        { text: "Instagram",value:"Instagram"},
        { text: "TikTok",value:"TikTok"},
        { text: "AUBI-plus",value:"AUBI-plus"},
        { text: "Ausbildung.de",value:"Ausbildung.de"},
        { text: "Azubiyo",value:"Azubiyo"},
        { text: "Bundesagentur für Arbeit",value:"Bundesagentur für Arbeit"},
        { text: "Direkt-Pass",value:"Direkt-Pass"},
        { text: "Duale Hochschule Baden-Württemberg",value:"Duale Hochschule Baden-Württemberg"},
        { text: "Schülerkarriere",value:"Schülerkarriere"},
        { text: "Studyflix",value:"Studyflix"},
        { text: "Ausbildungsmesse",value:"Ausbildungsmesse"},
        { text: "IHK Speed Dating",value:"IHK Speed Dating"},
        { text: "Schulische Berufsinformationsveranstaltung",value:"Schulische Berufsinformationsveranstaltung"},
        { text: "Printanzeige",value:"Printanzeige"},
        { text: "Mitarbeitende werben Mitarbeitende",value:"Mitarbeitende werben Mitarbeitende"},
        { text: "Sonstiges",value:"Sonstiges"},
    ],
     BecomingAwareThroughLeader: [
        { text: "Homepage der BBBank",value:"Homepage der BBBank"},
        { text: "Google",value:"Google"},
        { text: "Stepstone",value:"Stepstone"},
        { text: "LinkedIn",value:"LinkedIn"},
        { text: "XING",value:"XING"},
        { text: "Indeed",value:"Indeed"},
        { text: "Instagram",value:"Instagram"},
        { text: "Facebook",value:"Facebook"},
        { text: "Mitarbeitende werben Mitarbeitende",value:"Mitarbeitende werben Mitarbeitende"},
        { text: "Interne Bewerbung",value:"Interne Bewerbung"},
        { text: "Jobteaser",value:"Jobteaser"},
        { text: "Printanzeige",value:"Printanzeige"},
        { text: "Veranstaltung/Messe",value:"Veranstaltung/Messe"},
        { text: "Plakatwerbung/Außenwerbung",value:"Plakatwerbung/Außenwerbung"},
        { text: "Sonstiges",value:"Sonstiges"},
    ],
    AdditionalConsent: [
        { text: "Um Ihr Profil bei der Auswahl von zukünftigen oder anderen Stellenausschreibungen auch im Falle einer Ablehnung berücksichtigen zu können, würden wir Ihre Bewerbungsunterlagen gerne für einen Zeitraum von drei Jahren in unserem Talentpool speichern. Dies erfolgt nur mit Ihrer Einwilligung. Sie können die Einwilligung ohne Auswirkung auf das Auswahlverfahren verweigern oder jederzeit mit Wirkung für die Zukunft per E-Mail an datenschutz@bbbank.de widerrufen. Ihre Einwilligung erteilen Sie durch Aktivieren des Kästchens.", value: "Um Ihr Profil bei der Auswahl von zukünftigen oder anderen Stellenausschreibungen auch im Falle einer Ablehnung berücksichtigen zu können, würden wir Ihre Bewerbungsunterlagen gerne für einen Zeitraum von drei Jahren in unserem Talentpool speichern. Dies erfolgt nur mit Ihrer Einwilligung. Sie können die Einwilligung ohne Auswirkung auf das Auswahlverfahren verweigern oder jederzeit mit Wirkung für die Zukunft per E-Mail an datenschutz@bbbank.de widerrufen. Ihre Einwilligung erteilen Sie durch Aktivieren des Kästchens." }
    ]
}
